import { render, staticRenderFns } from "./baseFooter.vue?vue&type=template&id=3a9e6a26&scoped=true"
import script from "./baseFooter.vue?vue&type=script&lang=js"
export * from "./baseFooter.vue?vue&type=script&lang=js"
import style0 from "./baseFooter.vue?vue&type=style&index=0&id=3a9e6a26&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9e6a26",
  null
  
)

export default component.exports